import { render } from "./OtherConfigPage.vue?vue&type=template&id=29045bf0&scoped=true"
import script from "./OtherConfigPage.vue?vue&type=script&lang=js"
export * from "./OtherConfigPage.vue?vue&type=script&lang=js"

import "./OtherConfigPage.vue?vue&type=style&index=0&id=29045bf0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29045bf0"]])

export default __exports__